import Button from "common/components/Button/Button"
import { EN_CALENDAR, ES_CALENDAR } from "common/utils/date"
import { withFormik } from "formik"
import { addLocale } from "primereact/api"
import { Calendar } from "primereact/calendar"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import * as Yup from "yup"
import { newDocumentoSelector } from "../redux/selectors/newDocumentoSelectors"
import { setFechaEmision } from "../redux/slices/newDocumentoSlice"

const FechaEmision = ({
  values,
  handleSubmit,
  onHide,
  handleChange,
  isValid,
}: $TSMigrationFixMe) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  addLocale("es", ES_CALENDAR)
  addLocale("en", EN_CALENDAR)

  const DATE_TODAY = new Date()

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='calendar'>
            {t("crear.facturaRec.modal.emisionDateLabel")}
          </label>
          <Calendar
            id='calendar'
            // @ts-expect-error TS(2769): No overload matches this call.
            autoFocus
            name='fechaEmision'
            value={values.fechaEmision}
            locale={language}
            dateFormat='dd/mm/yy'
            maxDate={DATE_TODAY}
            mask='99/99/9999'
            onChange={handleChange}
            showIcon
            baseZIndex={2302}
          />
        </div>
      </div>
      <div className='mt-4 col'>
        <div className='row justify-content-end align-items-center'>
          <a
            role='button'
            href='#'
            className='mr-3 link-cancel'
            onClick={onHide}
          >
            {t("crear.facturaRec.modal.cancelButton")}
          </a>
          <Button
            type='submit'
            disabled={!isValid}
            className='!tw-bg-primary'
          >
            {t("crear.facturaRec.modal.addButton")}
          </Button>
        </div>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  fechaEmision: Yup.string().min(3).required(),
})

const CreateWithFormik = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'fechaEmision' does not exist on type '{}...
  mapPropsToValues: ({ fechaEmision }) => ({
    fechaEmision: new Date(fechaEmision),
  }),
  handleSubmit: ({ fechaEmision }, { props }) => {
    // @ts-expect-error TS(2339): Property 'setFechaEmision' does not exist on type ...
    props.setFechaEmision(fechaEmision)
    // @ts-expect-error TS(2339): Property 'onHide' does not exist on type 'object'.
    props.onHide()
  },
})(FechaEmision)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  setFechaEmision: (fecha: $TSMigrationFixMe) =>
    dispatch(setFechaEmision(fecha)),
})

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  fechaEmision: newDocumentoSelector(state).fechaEmision,
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateWithFormik)
